import React from "react";
import { Input } from "@progress/kendo-react-inputs";
import { Error } from "@progress/kendo-react-labels";
import { FieldWrapper } from "@progress/kendo-react-form";

const ValidateInputPure = (props) => {
  let { validationMessage, visited, touched, modified, ...others } = props;

  return (
    <FieldWrapper>
      <div>
        <Input {...others} />
        {visited && validationMessage && <Error>{validationMessage}</Error>}
      </div>
    </FieldWrapper>
  );
};

export { ValidateInputPure as default };
